import { ArrowUpRight, CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import { useSiteContent } from "../content/SiteContentContext";

export default function BlogCard({ post, featured = false }) {
  const { content } = useSiteContent();
  return (
    <article className={featured ? "blog-card blog-card-featured" : "blog-card"} data-testid={`blog-card-${post.id}`}>
      <img src={post.cover_image_url} alt="" className="blog-card-image" data-testid={`blog-cover-${post.id}`} />
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span data-testid={`blog-category-${post.id}`}>{post.category}</span>
          <time data-testid={`blog-date-${post.id}`}><CalendarDays size={14} /> {post.published_date}</time>
        </div>
        <h2 data-testid={`blog-title-${post.id}`}>{post.title}</h2>
        {!featured && <p>{post.content.slice(0, 145)}…</p>}
        <Link to={`/blog/${post.id}`} className="blog-read-link" data-testid={`read-blog-${post.id}`}>{content.blog_read_label} <ArrowUpRight size={17} /></Link>
      </div>
    </article>
  );
}